import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { strings } from '@constants'
import { updateSharePrices } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Calendar, Label, Toggle } from '@baseV2'

import { InputsWrapper } from '../styles'

const SharePrices = ({ orgId, update, orgData }) => {
	const dispatch = useDispatch()
	const [enabled, setEnabled] = useState(false)
	const [date, setDate] = useState(Date.now())

	useEffect(() => {
		setEnabled(Boolean(orgData?.share_prices))
		setDate(orgData?.price_subscription_validity ? new Date(orgData?.price_subscription_validity).getTime() : Date.now())
	}, [orgData])

	const saveHandler = () => {
		dispatch(showLoader(true))
		updateSharePrices(orgId, enabled, enabled ? date : null)
			.then(() => dispatch(showToast(true, strings('msg_services_updated_success'), { type: TOAST_TYPE.SUCCESS })))
			.catch((error) => dispatch(showToast(true, error?.message || strings('msg_service_update_fail'), { type: TOAST_TYPE.ERROR })))
			.finally(() => {
				update()
				dispatch(showLoader(false))
			})
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
						<Label>{strings(['share', 'prices'])}</Label>
						<Toggle
							options={[
								{ label: 'ON', active: enabled, click: () => setEnabled(true) },
								{ label: 'OFF', active: !enabled, click: () => setEnabled(false) },
							]}
						/>
					</div>
					{enabled && (
						<Calendar
							id='share-prices-validity'
							label={strings('select', 'date')}
							value={date}
							onChange={(value) => setDate(value)}
							minDate={new Date()}
						/>
					)}
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' onClick={saveHandler}>
					{strings('save')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default SharePrices
